import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { ComponentHeaderAuth, ComponentPdpa, ComponentQRcode, StyledNewHome } from "@components";
import { enumNavigation, PATH_TIER_DETAIL, PATH_USER_SETTING } from "@configs";
import { ModuleHistory, ModulesBenefit, ModulesCoupon, ModulesReward } from "@modules";
import { selectAuth, selectMerchant, selectNotSaveLocal, setNavigationType } from "@redux";
import { ComponentNewHome } from "src/Components/NewHome";

export const PageNewHome = () => {
    //page hook
    const history = useHistory();
    const dispatch = useDispatch();
    //page redux
    const { userInfo } = useSelector(selectAuth);
    const { themes, memberShipTiers } = useSelector(selectMerchant);
    const { navigationType } = useSelector(selectNotSaveLocal);
    //page state
    const [showQrCode, setShowQrCode] = useState<boolean>(false);

    const handleToggleUnder = (values: enumNavigation) => {
        dispatch(setNavigationType(values));
    };

    const handleToggleQrCode = () => {
        setShowQrCode(!showQrCode);
    };

    const handleSwitchUserSetting = () => {
        history.push(PATH_USER_SETTING);
    };

    const handleSwitchTier = () => {
        history.push(PATH_TIER_DETAIL);
    };

    const handleInitalQrCode = () => {
        setShowQrCode(false);
    };
    // const handleCoupon = () => {
    //     dispatch(setNavigationType(enumNavigation.COUPON_MERCHANT));
    // };

    const render = () => {
        switch (navigationType) {
            case enumNavigation.USER_POINT:
                return <ModulesReward />;
            case enumNavigation.BENEFIT:
                return <ModulesBenefit />;
            case enumNavigation.COUPON:
                return <ModulesCoupon under={navigationType} />;
            case enumNavigation.HISTORY:
                return <ModuleHistory />;
            case enumNavigation.COUPON_MERCHANT:
                return <ModulesCoupon under={navigationType} />;
            default:
                return <></>;
        }
    };

    return (
        <ComponentHeaderAuth handleInitalQrCode={handleInitalQrCode}>
            <StyledNewHome mainColor={themes?.themeColor!}>
                {!showQrCode && (
                    <>
                        <ComponentNewHome
                            under={navigationType}
                            handleToggleUnder={handleToggleUnder}
                            userInfo={userInfo}
                            memberShipTiers={memberShipTiers || []}
                            themeColor={themes?.themeColor!}
                            handleToggleQrCode={handleToggleQrCode}
                            handleSwitchUserSetting={handleSwitchUserSetting}
                            handleSwitchTier={handleSwitchTier}
                            // handleCoupon={handleCoupon}
                        />
                        {/* <StyledContainerHome>{render()}</StyledContainerHome> */}
                    </>
                )}
                {showQrCode && <ComponentQRcode handleToggleQrCode={handleToggleQrCode} />}
                <ComponentPdpa />
            </StyledNewHome>
        </ComponentHeaderAuth>
    );
};
